import { Body, Box, Icon } from '../'
import { Card } from './Card.jsx'
import './ExpandableCard.scss'

export const ExpandableCard = ({ headerTitle, content, expandedContent, selected, width = 327, ...props }) => (
  <Box className="card-header-container" width={width}>
    {headerTitle && <Box className="card-header">
      <Body>{headerTitle}</Body>
    </Box>}
    <Card
      width={width}
      selected={selected}
      {...props}
    >
      <Box column p={16} gap={8} fullWidth fullHeight>
        <Box fullWidth gap={8} fullHeight>
          <Box justifyContent="space-between" fullWidth fullHeight>
            {content}
          </Box>
          <Box width={32} mt={-4}>
            <Icon icon={selected ? 'Down' : 'Up'}/>
          </Box>
        </Box>
        {selected && expandedContent}
      </Box>
    </Card>
  </Box>
)